/* BG: <bg-offer-bar> — fixed Klaviyo offer bar (sections/bg-offer-bar.liquid).
   Click / Enter / Space -> window._klOnsite.push(['openForm', id]) with the mobile id at <=767px, the desktop id otherwise
   (same handler as the live inline script). A ResizeObserver keeps --bg-offer-bar-height (body padding-top, header offset)
   equal to the rendered height; the CSS default of 48px means there is no layout shift on load. */
if (!customElements.get('bg-offer-bar')) {
  customElements.define(
    'bg-offer-bar',
    class BgOfferBar extends HTMLElement {
      constructor() {
        super();
        this.onActivate = this.onActivate.bind(this);
        this.onKeydown = this.onKeydown.bind(this);
        this.syncHeight = this.syncHeight.bind(this);
      }

      connectedCallback() {
        this.addEventListener('click', this.onActivate);
        this.addEventListener('keydown', this.onKeydown);
        this.syncHeight();
        if ('ResizeObserver' in window) {
          this.resizeObserver = new ResizeObserver(this.syncHeight);
          this.resizeObserver.observe(this);
        } else {
          window.addEventListener('resize', this.syncHeight, { passive: true });
        }
      }

      disconnectedCallback() {
        this.removeEventListener('click', this.onActivate);
        this.removeEventListener('keydown', this.onKeydown);
        if (this.resizeObserver) this.resizeObserver.disconnect();
        window.removeEventListener('resize', this.syncHeight);
        // the bar was removed (e.g. disabled in the editor): let the stylesheet value (0px) apply again
        document.documentElement.style.removeProperty('--bg-offer-bar-height');
      }

      syncHeight() {
        const height = this.offsetHeight;
        if (height > 0) {
          document.documentElement.style.setProperty('--bg-offer-bar-height', `${height}px`);
        }
      }

      onKeydown(event) {
        if (event.key === 'Enter' || event.key === ' ' || event.key === 'Spacebar') {
          event.preventDefault();
          this.onActivate(event);
        }
      }

      onActivate(event) {
        if (event) event.preventDefault();
        const isMobile = window.matchMedia('(max-width: 767px)').matches;
        const formId = isMobile ? this.dataset.formMobile : this.dataset.formDesktop;
        if (!formId) return;
        (window._klOnsite = window._klOnsite || []).push(['openForm', formId]);
      }
    }
  );
}
